export const plansList = [
  {
    title: "free",
    image: "free",
    shekelPriceMonthly: 0,
    dollarPriceMonthly: 0,
    euroPriceMonthly: 0,
    shekelPriceYearly: 0,
    dollarPriceYearly: 0,
    euroPriceYearly: 0,
    typOfBillingYearly: "its-free",
    typOfBillingMonthly: "its-free",
    features: [
      "free-feature-1",
      "free-feature-2",
      "free-feature-3",
      "free-feature-4",
    ],
    linkMonthly: "",
    linkYearly: "",
    codePurchaseDisplay: false,
  },
  {
    title: "pro",
    image: "pro",
    shekelPriceMonthly: 42,
    dollarPriceMonthly: 12,
    euroPriceMonthly: 11,
    shekelPriceYearly: 420,
    dollarPriceYearly: 120,
    euroPriceYearly: 110,
    typOfBillingYearly: "billed-yearly",
    typOfBillingMonthly: "billed-monthly",
    features: [
      "pro-feature-1",
      "pro-feature-4",
      "pro-feature-2",
      "pro-feature-5",
      "pro-feature-3",
    ],
    linkMonthly: "purchase/pro/monthly",
    linkYearly: "purchase/pro/yearly",
    codePurchaseDisplay: true,
  },
  {
    title: "business",
    image: "business",
    shekelPriceMonthly: 79,
    dollarPriceMonthly: 20,
    euroPriceMonthly: 18,
    shekelPriceYearly: 790,
    dollarPriceYearly: 200,
    euroPriceYearly: 180,
    typOfBillingYearly: "billed-yearly",
    typOfBillingMonthly: "billed-monthly",
    features: [
      "business-feature-1",
      "business-feature-2",
      "business-feature-4",
      //"business-feature-3",
    ],
    linkMonthly: "purchase/purchase-details/subscription-business-monthly",
    linkYearly: "purchase/purchase-details/subscription-business-annually",
    codePurchaseDisplay: true,
  },
  {
    title: "premium",
    image: "premium",
    shekelPriceMonthly: 189,
    dollarPriceMonthly: 54,
    euroPriceMonthly: 44,
    shekelPriceYearly: 1890,
    dollarPriceYearly: 516,
    euroPriceYearly: 440,
    typOfBillingYearly: "billed-yearly",
    typOfBillingMonthly: "billed-monthly",
    features: ["premium-feature-1", "premium-feature-2"],
    linkMonthly: "purchase/premium/monthly",
    linkYearly: "purchase/premium/yearly",
    codePurchaseDisplay: false,
  },
];

export const plansObj = {
  free: {
    linkMonthly: "",
    linkYearly: "",
  },
  pro: {
    linkMonthly: "purchase/pro/monthly",
    linkYearly: "purchase/pro/yearly",
  },
  business: {
    linkMonthly: "purchase/business/monthly",
    linkYearly: "purchase/business/yearly",
  },
  premium: {
    linkMonthly: "purchase/premium/monthly",
    linkYearly: "purchase/premium/yearly",
  },
};

export const currencies = {
  ILS: "₪",
  EUR: "€",
  USD: "$",
};

export const eurList = [
  "Andorra",
  "Albania",
  "Austria",
  "Åland Islands",
  "Bosnia and Herzegovina",
  "Belgium",
  "Bulgaria",
  "Belarus",
  "Switzerland",
  "Cyprus",
  "Czech Republic",
  "Germany",
  "Denmark",
  "Estonia",
  "Spain",
  "Finland",
  "Faroe Islands",
  "France",
  "United Kingdon",
  "Guernsey",
  "Greece",
  "Croatia",
  "Hungary",
  "Ireland",
  "Isle of Man",
  "Iceland",
  "Italy",
  "Jersey",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Latvia",
  "Monaco",
  "Moldova, Republic of",
  "Macedonia, The Former Yugoslav Republic of",
  "Malta",
  "Netherlands",
  "Norway",
  "Poland",
  "Portugal",
  "Romania",
  "Russian Federation",
  "Sweden",
  "Slovenia",
  "Svalbard and Jan Mayen",
  "Slovakia",
  "San Marino",
  "Ukraine",
  "Holy See (Vatican City State)",
];
export const nisList = ["Israel"];